import styled from 'styled-components'
import vector from '../../../../assets/equipment/vector.svg'
import vectorlight from '../../../../assets/equipment/vectorlight.svg'

export const SubHeaderContainer = styled.div`
  background-color: #fff;
  margin-bottom: 0;
  padding: 0.45rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 8px;
`

export const MainContainer = styled.div`
  background-color: #f4f4f4;
  overflow-y: auto;
  padding: 20px 0;
  min-height: calc(100vh - 140px);
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const SectionName = styled.h2`
  font-size: 1rem;
  font-weight: 700;
  width: fit-content;
  margin: 0;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`

export const BreadcrumbsContainer = styled.nav`
  font-size: 14px;
  padding: 1rem 0rem;
  
  ol {
    list-style: none;
    padding: 0;
    padding-inline-start: 0;
    margin: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  
  li {
    display: flex;
    align-items: center;
    color: var(--light-text-color, #666);
    
    &:not(:last-child)::after {
      content: '>';
      margin: 0 8px;
      color: var(--input-border, #999);
    }
    
    a {
      text-decoration: none;
      color: #0090d3;
      white-space: nowrap;
      cursor: pointer;
    }
    
    &:last-child {
      span {
        color: var(--text-color, #333);
        white-space: nowrap;
        cursor: default;
      }
      
      a {
        color: var(--text-color, #333);
        cursor: default;
        text-decoration: none;
      }
    }
  }
`

export const StyledCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 25px 20px;
  margin-bottom: 20px;
`

export const StyledCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`

export const CardTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  padding-bottom: 20px;
`

export const FormGrid = styled.div<{ cols: number }>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.cols}, 1fr);
  gap: 20px 30px;
  
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  label {
    font-size: 14px;
    margin-bottom: 8px;
    font-weight: bold;
  }

  input,
  select {
    padding: 8px 15px;
    border: 1px solid var(--input-border, #ddd);
    border-radius: 100px;
    font-size: 14px;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    height: 40px;
    line-height: 22px;
    background-color: #ebebeb;
    color: #333;
    transition: border-color 0.2s, background-color 0.2s;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      -moz-appearance: textfield;
    }

    &::placeholder {
      color: #999;
    }

    &:hover {
      border-color: #cbd5e0;
    }

    &:focus {
      border-color: #3182ce;
      background-color: #fff;
    }

    &:disabled,
    &[readonly] {
      background-color: #c4c4c4;
      color: #696969;
      cursor: not-allowed;
      border-color: #dfdfdf;
    }
  }

  select {
    background-image: url(${vector});
    background-size: 18px 9px;
    background-repeat: no-repeat;
    background-position: right 15px center;
    padding-right: 2.5rem;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;

    option[value=''] {
      color: #999;
    }
    
    option {
      color: #333;
      background-color: white;
    }

    &:disabled,
    &[readonly] {
      background-image: url(${vectorlight});
      background-size: 32px 16px;
      cursor: not-allowed;
    }
  }
`

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
`

export const CancelButton = styled.button`
  background-color: #ffffff;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background-color: #e6f7ff;
  }
`

export const SaveButton = styled.button`
  background-color: #0090d3;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;

  &:hover:not(:disabled) {
    background-color: #0077b3;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  img {
    width: 16px;
    height: 16px;
  }
`

export const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  max-height: 250px;
  overflow-y: auto;
  margin-top: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`

export const DropdownItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
  font-size: 14px;
  color: #333;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:last-child {
    border-bottom: none;
  }
`

export const AddButton = styled.button`
  background-color: transparent;
  color: #0090d3;
  border: 1px solid #0090d3;
  padding: 12px 24px;
  border-radius: 100px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  gap: 8px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  img {
    width: 12px;
    height: 12px;
  }
`

export const MaterialItemContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 20px;
  align-items: start;
  border-radius: 12px;
  border: 1px solid #d0d0d0;
  padding: 16px;
  margin-bottom: 12px;
`

export const MaterialFields = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const InlineDeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  color: #00bcd4;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  margin-top: 20px;
  min-width: 40px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  img {
    width: 20px;
    height: 20px;
  }
`

export const SectionButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
  padding-top: 16px;
`
